export const isTotalLoss = (damage) => String(damage?.damage_type || '').trim().toLowerCase() === 'totalschaden';
export const isTotalLossItem = (item) => /\btotalschaden\b/i.test(item?.name || '');

export function totalLossSB(booking, vehicle, fallback = '') {
  // A contractual zero is an agreed waiver and must not fall back to vehicle SB.
  for (const value of [booking?.insurance_deductible, vehicle?.insurance_deductible, fallback]) {
    if (value !== null && value !== undefined && value !== '') return String(value);
  }
  return '';
}

export function applyDamageCatalog(form, item, booking, vehicle) {
  if (isTotalLossItem(item)) return {
    ...form,
    damage_type: 'Totalschaden', severity: 'major',
    description: item.default_description || 'Totalschaden am Fahrzeug. Abrechnung der vereinbarten Selbstbeteiligung.',
    estimated_cost: item.default_cost != null ? String(item.default_cost) : '',
    actual_cost: '',
    deductible_applied: totalLossSB(booking, vehicle, item.default_deductible ?? form.deductible_applied),
  };
  return {
    ...form,
    damage_type: isTotalLoss(form) ? 'Sonstiges' : form.damage_type,
    description: item.default_description || form.description,
    estimated_cost: item.default_cost != null ? String(item.default_cost) : form.estimated_cost,
    actual_cost: item.default_cost != null && !form.actual_cost ? String(item.default_cost) : form.actual_cost,
    deductible_applied: item.default_deductible != null ? String(item.default_deductible) : form.deductible_applied,
  };
}
